const styles = () => ({
    volumeController: {
        opacity: 0,
        transition: 'opacity 200ms',
    },
});
export default styles;
